<template>
  <div>
    <div class="ir-sub-menu">
      <ul>
        <li>
          <a href="/ir/library">決算短信</a>
        </li>
        <li>
          <a href="/ir/securities">有価証券報告書</a>
        </li>
        <li>
          <a href="/ir/presentation" class="selected">決算説明会資料</a>
        </li>
        <li>
          <a href="/ir/material">IR資料</a>
        </li>
      </ul>
    </div>
    <section>
      <div class="l-service">
        <div class="l-service-header">
          <h2 class="heading-default heading-default-center">決算説明会資料</h2>
          <h3 class="heading-small heading-small-center heading-small-mt-sp">
            PRESENTATION
          </h3>

          <div class="l-service-content-inner">
            <!-- E-IR Parts -->
            <div id="eirArea"></div>
            <div id="doEirWrapper"></div>
            <!-- /E-IR Parts -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "決算説明会資料",
      titleTemplate:
        "決算説明会資料 | IRライブラリー | IR情報 | 株式会社 旅工房",
    };
  },
  mounted: function () {
    let doEirWrapper = document.getElementById("doEirWrapper");
    let doEirScript = document.createElement("script");
    doEirScript.innerHTML = 'setParts("presentation")';
    doEirWrapper.appendChild(doEirScript);
  },
};
</script>
